export interface StackPlanViewModel {
  id?: number;
  propertyType?: string;
  showUnaccountedSpace?: boolean;
  showNonRentableSpace?: boolean;
  isSmoothView?: boolean;
}

export const PV_VIEW_STATE_KEY = 'PV_STACK_VIEW_STATE';
